<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Rozliczenia'" [name]="'Lista'"></app-breadcrumb>
<div class="commission-settlement-list-container" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">

      <mat-form-field class="commission-settlement-list-filter">
        <mat-label>Numer</mat-label>
        <input matInput placeholder="Numer" name="number" [(ngModel)]="initialFilters.number">
      </mat-form-field>

      <app-month-picker
        class="commission-settlement-list-filter"
        label="Miesiąc rozliczeniowy" [required]="false"
        name="billingMonth" [(ngModel)]="initialFilters.billingMonth"
      ></app-month-picker>

      <app-dict-ofwcas
        [multiple]="false" label="OFWCA"
        class="commission-settlement-list-filter"
        [(ngModel)]="initialFilters.ofwca" name="ofwca"
      ></app-dict-ofwcas>

      <app-dict-partners
        [multiple]="false" label="Partner"
        class="commission-settlement-list-filter"
        [(ngModel)]="initialFilters.partner" name="partner"
      ></app-dict-partners>

      <mat-form-field appearance="standard" class="commission-settlement-list-filter">
        <mat-label>Strona umowy</mat-label>
        <mat-select
          [(ngModel)]="initialFilters.owner" name="owner"
          [multiple]="false"
        >
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="'ofwca'">OFWCA</mat-option>
          <mat-option [value]="'partner'">Partner</mat-option>
        </mat-select>
      </mat-form-field>

      <app-dict
        [multiple]="true" label="Status"
        class="commission-settlement-list-filter"
        dictType="commission_settlement_status"
        [(ngModel)]="initialFilters.in$status" name="in$status"
      ></app-dict>

      <mat-form-field class="commission-settlement-list-filter">
        <mat-label>Suma inkaso od</mat-label>
        <input matInput placeholder="Suma inkaso od" name="gte$totalCollection" [(ngModel)]="initialFilters.gte$totalCollection">
      </mat-form-field>

      <mat-form-field class="commission-settlement-list-filter">
        <mat-label>Suma inkaso do</mat-label>
        <input matInput placeholder="Suma inkaso do" name="lte$totalCollection" [(ngModel)]="initialFilters.lte$totalCollection">
      </mat-form-field>

      <mat-form-field class="commission-settlement-list-filter">
        <mat-label>Suma prowizji od</mat-label>
        <input matInput placeholder="Suma prowizji od" name="gte$totalCommission" [(ngModel)]="initialFilters.gte$totalCommission">
      </mat-form-field>

      <mat-form-field class="commission-settlement-list-filter">
        <mat-label>Suma prowizji do</mat-label>
        <input matInput placeholder="Suma prowizji do" name="lte$totalCommission" [(ngModel)]="initialFilters.lte$totalCommission">
      </mat-form-field>

      <app-dict-regionals
        [multiple]="false" label="Regionalny (majątek)"
        class="commission-settlement-list-filter"
        [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
      ></app-dict-regionals>

      <app-dict
        [multiple]="false" label="Typ umowy"
        class="commission-settlement-list-filter"
        dictType="contract_type"
        [(ngModel)]="initialFilters.contractType" name="contractType"
      ></app-dict>

    </form>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>
    <button   *ngIf="(userPermissions | async).settlement.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <div fxLayout="column">
    <table mat-table [dataSource]="items">

      <ng-container matColumnDef="party">
        <th mat-header-cell *matHeaderCellDef> Partner/OFWCA </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.partner">
            <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
          </ng-container>

          <ng-container *ngIf="element.ofwca">
            <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="contractOwner">
        <th mat-header-cell *matHeaderCellDef> Strona umowy </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.partner">
            Partner
          </ng-container>

          <ng-container *ngIf="element.ofwca">
            OFWCA
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef> Numer </th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" [routerLink]="['/rozliczenia/szczegoly', element?.uuid]">
            {{element.number}}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="billingMonth">
        <th mat-header-cell *matHeaderCellDef> Miesiąc rozliczeniowy </th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" [routerLink]="['/rozliczenia/szczegoly', element?.uuid]">
            {{element.billingMonth}} -
            <ng-container *ngIf="element.partner">
              {{element.partner?.shortName}}
            </ng-container>

            <ng-container *ngIf="element.ofwca">
              {{element.ofwca.fullName}}
            </ng-container>
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
          <button mat-raised-button [ngClass]="element.status.color + '-button'">
            {{element.status.name}}
          </button>
<!--          <button *ngIf="element.status && element.status.key !== COMMISSION_SETTLEMENT_STATUS_TO_GENERATE" mat-raised-button [ngClass]="element.status.color + '-button'">-->
<!--            {{element.status.name}}-->
<!--          </button>-->
<!--          <button *ngIf="element.status && element.status.key === COMMISSION_SETTLEMENT_STATUS_TO_GENERATE"-->
<!--                  mat-raised-button-->
<!--                  [ngClass]="element.status.color + '-button settlement-generate-button'"-->
<!--                  (click)="generateCommissionSettlements(element)"-->
<!--          >-->
<!--            <mat-icon>refresh</mat-icon> {{element.status.name}}-->
<!--          </button>-->
        </td>
      </ng-container>

      <ng-container matColumnDef="totalCollection">
        <th mat-header-cell *matHeaderCellDef> Suma inkaso </th>
        <td mat-cell *matCellDef="let element">
          {{element.totalCollection | number:'1.2-2'}} zł
        </td>
      </ng-container>

      <ng-container matColumnDef="totalCommission">
        <th mat-header-cell *matHeaderCellDef> Suma prowizji </th>
        <td mat-cell *matCellDef="let element">
          {{(element.totalCommission === null ? 0 : element.totalCommission) | number:'1.2-2'}} zł
        </td>
      </ng-container>

      <ng-container matColumnDef="assetsRegional">
        <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.partner">
            {{element.partner?.assetsRegional?.fullName}}
          </ng-container>

          <ng-container *ngIf="element.ofwca">
            {{element.ofwca?.assetsRegional?.fullName}}
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>

</div>
